// VALIDATED FEEDER machine_card fixture — the ground-truth renderer-builder
// example, copied verbatim from API_CONTRACTS.md ~2861-2921 (real 10-Jun backfill
// numbers, STALE + historical_backfill, the two-clock split). Used by the honesty
// unit tests and (later) the SP-6 fixture harness. This is the NORMAL state right
// now — MASH has been DARK since 2026-06-12.
import type { MachineCardArtifactData } from "../../../chatBot/models/machineEvidenceModels";

/** GUID from the canonical example — used to test the identity invariant. */
export const FEEDER_MACHINE_GUID = "d72d27d9-0308-49e6-7c19-08dec02ae617";

export const FEEDER_MACHINE_CARD: MachineCardArtifactData = {
  schema_version: 1,
  mode: "snapshot",
  machine: {
    machine: "d72d27d9-0308-49e6-7c19-08dec02ae617",
    machine_id_full: "d72d27d9-0308-49e6-7c19-08dec02ae617",
    class_template: null,
    display_name: "MASHi2601",
  },
  freshness: {
    state: "STALE",
    as_of: "2026-06-30T16:33:00+00:00",
    last_sample_at: "2026-06-29T18:08:27.134590+00:00",
    age_seconds: 73454,
    source: "mash_liveness",
    provenance: "historical_backfill",
    event_time: "2026-06-10T09:24:53.263000+00:00",
  },
  tabs: [
    {
      part_slug: "feeders",
      name: "Feeders",
      parent_slug: null,
      verdict: {
        status: "stale",
        headline: "Feeder presentation: 2172 NOK occurrences this window across 4 bowl(s)",
        detail: null,
        basis: "occurrence count (no calibrated threshold this milestone)",
      },
      lane_coverage: {},
      figures: [
        {
          id: "f_feeder_presentation_nok",
          label: "Feeder presentation NOK",
          value: 2172,
          unit: null,
          window: "2026-06-10 → 2026-06-10",
          window_start: "2026-06-10T00:00:00+02:00",
          window_end: "2026-06-11T00:00:00+02:00",
          denominator: null,
          coverage: "ok",
          measure_basis: null,
          threshold: null,
          n: 2172,
          source_ref: "s_feeder_presentation_nok",
          freshness: null,
          breakdown: {
            pending: false,
            pending_reason: null,
            group_label: "bowl",
            truncated: null,
            rows: [
              { label: "bowl 2", value: 1936, unit: null, denominator: null, n: 1936 },
              { label: "bowl 4", value: 107, unit: null, denominator: null, n: 107 },
              { label: "bowl 3", value: 66, unit: null, denominator: null, n: 66 },
              { label: "bowl 1", value: 63, unit: null, denominator: null, n: 63 },
            ],
          },
        },
        {
          id: "f_feeder_starvation",
          label: "Feeder starvations",
          value: 54,
          unit: null,
          window: "2026-06-10 → 2026-06-10",
          window_start: "2026-06-10T00:00:00+02:00",
          window_end: "2026-06-11T00:00:00+02:00",
          denominator: null,
          coverage: "ok",
          measure_basis: null,
          threshold: null,
          n: 54,
          source_ref: "s_feeder_starvation",
          freshness: null,
          breakdown: null,
        },
        {
          id: "f_feeder_refill",
          label: "Material refills",
          value: 36,
          unit: null,
          window: "2026-06-10 → 2026-06-10",
          window_start: "2026-06-10T00:00:00+02:00",
          window_end: "2026-06-11T00:00:00+02:00",
          denominator: null,
          coverage: "ok",
          measure_basis: null,
          threshold: null,
          n: 36,
          source_ref: "s_feeder_refill",
          freshness: null,
          breakdown: null,
        },
        {
          id: "f_feeder_can_reset",
          label: "Feeder CAN resets",
          value: 18,
          unit: null,
          window: "2026-06-10 → 2026-06-10",
          window_start: "2026-06-10T00:00:00+02:00",
          window_end: "2026-06-11T00:00:00+02:00",
          denominator: null,
          coverage: "ok",
          measure_basis: null,
          threshold: null,
          n: 18,
          source_ref: "s_feeder_can_reset",
          freshness: null,
          breakdown: null,
        },
      ],
      trend: null,
      live: null,
    },
  ],
  sources: [
    {
      id: "s_feeder_presentation_nok",
      signal_key: "feeder_presentation_nok",
      window: "2026-06-10 → 2026-06-10",
      window_start: "2026-06-10T00:00:00+02:00",
      window_end: "2026-06-11T00:00:00+02:00",
      count: 2172,
      source_grain: "event",
      read_source: "telemetry store",
      edge_path: null,
    },
    {
      id: "s_feeder_starvation",
      signal_key: "feeder_starvation",
      window: "2026-06-10 → 2026-06-10",
      window_start: "2026-06-10T00:00:00+02:00",
      window_end: "2026-06-11T00:00:00+02:00",
      count: 54,
      source_grain: "rollup_cagg",
      read_source: "telemetry store",
      edge_path: null,
    },
    {
      id: "s_feeder_refill",
      signal_key: "feeder_refill",
      window: "2026-06-10 → 2026-06-10",
      window_start: "2026-06-10T00:00:00+02:00",
      window_end: "2026-06-11T00:00:00+02:00",
      count: 36,
      source_grain: "rollup_cagg",
      read_source: "telemetry store",
      edge_path: null,
    },
    {
      id: "s_feeder_can_reset",
      signal_key: "feeder_can_reset",
      window: "2026-06-10 → 2026-06-10",
      window_start: "2026-06-10T00:00:00+02:00",
      window_end: "2026-06-11T00:00:00+02:00",
      count: 18,
      source_grain: "rollup_cagg",
      read_source: "telemetry store",
      edge_path: null,
    },
  ],
  frozen: { is_frozen: false, frozen_at: null },
};
